// 目录：
// 将声明的内容复制到屏幕可见区域
//判断非语义 heading（role=heading）是否缺少 aria-level；原生 h1–h6 不添加冗余 ARIA
// 给图片添加alt属性，如果图片本身不带文字，则需要alt控制，如果图片带文字，需要写alt具体文字
// 给所有的svg判断是否包含aria-hidden，如果不包含，则添加
// 给未关联 label / 无 ARIA 名称的 input 补 visually-hidden <label>；required 时补 aria-required；MutationObserver 覆盖第三方动态表单
// 单页唯一 h1（可配置：singleH1Fun(options) / window.ADA_SINGLE_H1_CONFIG）：保留首个内容 h1；全页无 h1 时升主内容首个 h2
// tab键盘focus元素，当按下enter回车则触发元素的click事件

function announcementAccessFun() {
  document.addEventListener("DOMContentLoaded", function () {
    const announcement = document.getElementById("accessibility-announcement");
    // 创建一个函数来发布声明
    function announceAccessibilityStatement() {
      // 将声明的内容复制到屏幕可见区域
      const visibleAnnouncement = document.createElement("div");
      visibleAnnouncement.style.position = "absolute";
      visibleAnnouncement.style.top = "0";
      visibleAnnouncement.style.left = "0";
      visibleAnnouncement.style.width = "1px";
      visibleAnnouncement.style.height = "1px";
      visibleAnnouncement.style.overflow = "hidden";
      visibleAnnouncement.innerHTML = announcement.innerHTML;
      announcement.appendChild(visibleAnnouncement);
      // 移除声明内容（可选）
      setTimeout(() => {
        if (visibleAnnouncement.parentNode) {
          visibleAnnouncement.parentNode.removeChild(visibleAnnouncement);
        }
      }, 5000); // 保留一段时间以确保屏幕阅读器能够读取
    }

    // 调用函数发布声明
    announceAccessibilityStatement(); 
  });
}

function targetlinkFun() {
  // ADA: Remove redundant title; expose file type + new-tab in accessible name (WCAG 2.4.4 / 2.4.9).
  var links = document.querySelectorAll("a[href]");
  var currentHost = window.location.hostname;
  var newTabSuffix = ", opens in new tab";
  var fileTypeMap = {
    pdf: "PDF",
    doc: "Word document",
    docx: "Word document",
    xls: "Excel spreadsheet",
    xlsx: "Excel spreadsheet",
    ppt: "PowerPoint presentation",
    pptx: "PowerPoint presentation",
    zip: "ZIP archive",
  };

  function normalizeText(value) {
    return String(value || "")
      .trim()
      .replace(/\s+/g, " ");
  }

  function isExternalLink(href, host) {
    try {
      var url = new URL(href, window.location.href);
      if (url.protocol === "mailto:" || url.protocol === "tel:" || url.protocol === "javascript:") {
        return false;
      }
      return url.hostname !== "" && url.hostname !== host;
    } catch (e) {
      return false;
    }
  }

  function getFileTypeSuffix(href) {
    if (!href) return "";

    var candidates = [String(href)];
    try {
      var url = new URL(href, window.location.href);
      candidates.push(url.pathname, url.href);
    } catch (e) {
      /* keep raw href candidate */
    }

    // Match known extensions before ?/# or end — covers "...Manual.pdf?v=123"
    var extPattern = /\.(pdf|docx?|xlsx?|pptx?|zip)(?=[?#]|$)/i;

    for (var i = 0; i < candidates.length; i++) {
      var value = candidates[i];
      try {
        value = decodeURIComponent(value);
      } catch (e) {
        /* keep undecoded value */
      }

      var match = String(value).toLowerCase().match(extPattern);
      if (!match) continue;

      var label = fileTypeMap[match[1]];
      if (label) return ", " + label + " file";
    }

    return "";
  }

  function stripKnownSuffixes(label) {
    return normalizeText(label)
      .replace(/,?\s*opens in new (tab|window)/gi, "")
      .replace(
        /,?\s*(PDF|Word document|Excel spreadsheet|PowerPoint presentation|ZIP archive)\s+file/gi,
        ""
      )
      .replace(/,\s*$/, "")
      .trim();
  }

  function removeRedundantTitle(link, linkText) {
    if (!link.hasAttribute("title")) return;
    var titleText = normalizeText(link.getAttribute("title"));
    // Same as visible text → redundant SR announcement; remove title.
    if (!titleText || titleText === linkText) {
      link.removeAttribute("title");
    }
  }

  function buildAccessibleLabel(linkText, fileSuffix, opensNewTab, existingLabel) {
    var label = stripKnownSuffixes(existingLabel || linkText) || linkText;
    if (!label) return "";

    if (fileSuffix) label += fileSuffix;
    if (opensNewTab) label += newTabSuffix;
    return label;
  }

  for (var i = 0; i < links.length; i++) {
    var link = links[i];
    if (link.hasAttribute("aria-labelledby")) continue;

    var linkText = normalizeText(link.textContent);
    removeRedundantTitle(link, linkText);

    var href = link.getAttribute("href") || link.href;
    var fileSuffix = getFileTypeSuffix(href);
    var isExternal = isExternalLink(href, currentHost);

    if (isExternal && link.target !== "_blank") {
      link.target = "_blank";
      link.rel = "noopener noreferrer";
    }

    var opensNewTab = link.target === "_blank" || isExternal;
    // File links always need type in aria-label; new-tab links need opens-in-new-tab notice.
    if (!fileSuffix && !opensNewTab) continue;

    var nextLabel = buildAccessibleLabel(
      linkText,
      fileSuffix,
      opensNewTab,
      link.getAttribute("aria-label")
    );
    if (nextLabel) {
      link.setAttribute("aria-label", nextLabel);
    }
  }
}

function titleroleFun() {
  // Native h1–h6 already expose heading role and level. Adding role="heading" or
  // aria-label that mirrors textContent causes duplicate screen-reader announcements.
  document.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach(function (heading) {
    if (heading.getAttribute('role') === 'heading') {
      heading.removeAttribute('role');
    }

    if (heading.hasAttribute('aria-label')) {
      var visibleText = heading.textContent.trim().replace(/\s+/g, ' ');
      var ariaLabel = heading.getAttribute('aria-label').trim().replace(/\s+/g, ' ');
      if (!visibleText || ariaLabel === visibleText) {
        heading.removeAttribute('aria-label');
      }
    }
  });

  // Non-native elements with role="heading" must include aria-level (WCAG / ARIA APG).
  document
    .querySelectorAll('[role="heading"]:not(h1):not(h2):not(h3):not(h4):not(h5):not(h6)')
    .forEach(function (element) {
      if (element.hasAttribute('aria-level')) return;

      var level = 2;
      var cls = typeof element.className === 'string' ? element.className : '';

      if (/\b(h1|__h1|-h1)\b/i.test(cls)) level = 1;
      else if (/\b(h3|__h3|-h3)\b/i.test(cls)) level = 3;
      else if (/\b(h4|__h4|-h4)\b/i.test(cls)) level = 4;
      else if (/\b(h5|__h5|-h5)\b/i.test(cls)) level = 5;
      else if (/\b(h6|__h6|-h6)\b/i.test(cls)) level = 6;

      element.setAttribute('aria-level', String(level));
    });
}

function processImageAlt(image) {
  if (image.hasAttribute("aria-hidden")) return;
  if (image.hasAttribute("data-decorative")) return;
  if (image.closest("[aria-hidden='true']")) return;
  if (image.classList.contains("product-chart-hover")) return;

  var hasAlt = image.hasAttribute("alt");
  var altValue = hasAlt ? String(image.getAttribute("alt") || "").trim() : "";

  if (!hasAlt) {
    image.setAttribute("alt", "");
    image.setAttribute("aria-hidden", "true");
    return;
  }

  if (altValue === "") {
    image.setAttribute("aria-hidden", "true");
  }
}

function processImagesInRoot(root) {
  if (!root || !root.querySelectorAll) return;
  root.querySelectorAll("img").forEach(processImageAlt);
}

function observeImageAltInRoot(root) {
  if (!root || root.nodeType !== 1 || root.dataset.imgAltObserved) return;
  root.dataset.imgAltObserved = "1";

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.tagName === "IMG") {
          processImageAlt(node);
        } else if (node.querySelectorAll) {
          node.querySelectorAll("img").forEach(processImageAlt);
          if (node.tagName === "IFRAME") {
            bindIframeImageAlt(node);
          }
        }
      });
    });
  }).observe(root, { childList: true, subtree: true });
}

function bindIframeImageAlt(iframe) {
  function run() {
    try {
      var doc = iframe.contentDocument;
      if (!doc || !doc.body) return;
      processImagesInRoot(doc);
      observeImageAltInRoot(doc.body);
    } catch (e) {
      // Cross-origin iframe — not accessible from theme JS.
    }
  }

  run();
  iframe.addEventListener("load", run);
}

function imgALTFun() {
  processImagesInRoot(document);
  document.querySelectorAll("iframe").forEach(bindIframeImageAlt);
  observeImageAltInRoot(document.body);
}

function svgariaFun() {
  // 给所有的svg判断是否包含aria-hidden，如果不包含，则添加
  const svgs = document.getElementsByTagName("svg");

  Array.from(svgs).forEach((svg) => {
    if (!svg.hasAttribute("aria-hidden")) {
      svg.setAttribute("aria-hidden", "true");
      svg.setAttribute("focusable", "false");
    }
  });
}

function inputHasAssociatedLabel(input) {
  return Boolean(input.labels && input.labels.length > 0);
}

function inputHasAccessibleName(input) {
  if (inputHasAssociatedLabel(input)) return true;
  if (input.hasAttribute("aria-labelledby")) return true;
  if ((input.getAttribute("aria-label") || "").trim()) return true;
  return false;
}

function ensureInputId(input) {
  if (input.id) return input.id;
  const id = "ada-input-" + Math.random().toString(36).slice(2, 10);
  input.id = id;
  return id;
}

function getInputFallbackLabelText(input) {
  // Prefer placeholder / name; never use the live value (it changes with typing).
  return (
    (input.getAttribute("placeholder") || "").trim() ||
    (input.getAttribute("name") || "").trim() ||
    (input.getAttribute("type") || input.tagName || "text").toString().trim() ||
    "Input"
  );
}

function getAreviewsControlLabelText(el) {
  var hint = (
    (el.getAttribute("placeholder") || "") +
    " " +
    (el.getAttribute("name") || "") +
    " " +
    (el.id || "") +
    " " +
    (el.className || "")
  ).toLowerCase();

  if (el.type === "file" || /file|photo|image|upload|picture/.test(hint)) return "Upload photo";
  if (/email/.test(hint)) return "Email";
  if (/name|author|nick/.test(hint)) return "Name";
  if (/title|subject/.test(hint)) return "Review title";
  if (/body|content|review|comment|message/.test(hint)) return "Review";
  if (/rating|star/.test(hint)) return "Rating";
  return getInputFallbackLabelText(el);
}

function labelControlIfNeeded(control) {
  if (!control) return;
  var tag = control.tagName;
  if (tag !== "INPUT" && tag !== "SELECT" && tag !== "TEXTAREA") return;
  if (tag === "INPUT" && control.type === "hidden") return;

  if (control.hasAttribute("required")) {
    control.setAttribute("aria-required", "true");
  }

  if (inputHasAccessibleName(control)) return;
  if (control.dataset.adaLabelled === "1") return;

  var id = ensureInputId(control);
  var label = document.createElement("label");
  label.setAttribute("for", id);
  label.className = "visually-hidden";
  label.setAttribute("data-ada-generated-label", "1");
  label.textContent = control.closest("#enter_reviews, #az_reviews, .AReviewsApp")
    ? getAreviewsControlLabelText(control)
    : getInputFallbackLabelText(control);

  control.dataset.adaLabelled = "1";
  control.insertAdjacentElement("afterend", label);
}

function processInputsInRoot(root) {
  if (!root || !root.querySelectorAll) return;
  if (root.matches && root.matches("input:not([type='hidden'])")) {
    labelControlIfNeeded(root);
  }
  root.querySelectorAll("input:not([type='hidden'])").forEach(labelControlIfNeeded);
}

function observeInputLabelsInRoot(root) {
  if (!root || root.nodeType !== 1 || root.dataset.inputLabelObserved) return;
  root.dataset.inputLabelObserved = "1";

  var scheduled = false;
  function scheduleScan() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      processInputsInRoot(root);
    });
  }

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        // Skip labels we just inserted — avoids feedback loops
        if (node.getAttribute && node.getAttribute("data-ada-generated-label") === "1") {
          continue;
        }
        if (
          (node.matches && node.matches("input:not([type='hidden'])")) ||
          (node.querySelector && node.querySelector("input:not([type='hidden'])"))
        ) {
          scheduleScan();
          return;
        }
      }
    }
  }).observe(root, { childList: true, subtree: true });
}

function inputlabelFun() {
  // Insert visually-hidden <label for> so layout is unchanged (position:absolute clip).
  // Also watch for third-party / late-injected forms (apps, drawers, etc.).
  processInputsInRoot(document);
  if (document.body) {
    observeInputLabelsInRoot(document.body);
  }
}

function tabtoClickFun() {
  // tab键盘focus元素，当按下enter回车则触发元素的click事件
  // Skip controls that already activate on Enter natively (links, buttons, summary, form fields).
  document.addEventListener("keydown", function (event) {
    if (event.key !== "Tab") return;

    var focusedElement = document.activeElement;
    if (!focusedElement) return;

    focusedElement.addEventListener("keydown", function (event) {
      if (event.key !== "Enter") return;

      var tag = focusedElement.tagName;
      if (
        tag === "A" ||
        tag === "BUTTON" ||
        tag === "SUMMARY" ||
        tag === "INPUT" ||
        tag === "SELECT" ||
        tag === "TEXTAREA" ||
        focusedElement.getAttribute("role") === "button"
      ) {
        return;
      }

      focusedElement.click();
    });
  });
}

function getIframeAccessibleTitle(iframe) {
  var src = (iframe.getAttribute("src") || "").toLowerCase();

  if (iframe.hasAttribute("data-gapiattached") || iframe.closest("#google-rating-badge-slot")) {
    return "Google Customer Reviews rating badge";
  }
  if (src.indexOf("recaptcha") !== -1) {
    return "reCAPTCHA verification";
  }
  if (src.indexOf("translate.google") !== -1) {
    return "Google Translate widget";
  }
  if (src.indexOf("youtube.com") !== -1 || src.indexOf("youtu.be") !== -1) {
    return "YouTube video player";
  }
  if (src.indexOf("vimeo.com") !== -1) {
    return "Vimeo video player";
  }
  if (src.indexOf("google.com") !== -1) {
    return "Google embedded content";
  }
  return "Airthereal embedded content";
}

function ensureIframeTitle(iframe) {
  if (!iframe || iframe.tagName !== "IFRAME") return;
  if (iframe.hasAttribute("title") && iframe.getAttribute("title").trim() !== "") return;
  iframe.setAttribute("title", getIframeAccessibleTitle(iframe));
}

function sanitizeGoogleRatingBadgeIframe(iframe) {
  if (!iframe || iframe.tagName !== "IFRAME") return;
  if (!iframe.closest("#google-rating-badge-slot")) return;

  ensureIframeTitle(iframe);
  iframe.setAttribute("aria-hidden", "true");
  iframe.setAttribute("tabindex", "-1");
}

function googleRatingBadgeA11yFun() {
  var slot = document.getElementById("google-rating-badge-slot");
  if (!slot) return;

  slot.setAttribute("aria-hidden", "true");
  slot.querySelectorAll("iframe").forEach(sanitizeGoogleRatingBadgeIframe);

  new MutationObserver(function () {
    slot.setAttribute("aria-hidden", "true");
    slot.querySelectorAll("iframe").forEach(sanitizeGoogleRatingBadgeIframe);
  }).observe(slot, { childList: true, subtree: true });
}

function iframeTitleFun() {
  document.querySelectorAll("iframe").forEach(ensureIframeTitle);

  if (!document.body) return;
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.tagName === "IFRAME") {
          ensureIframeTitle(node);
        } else if (node.querySelectorAll) {
          node.querySelectorAll("iframe").forEach(ensureIframeTitle);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
}

function upgradeAreviewsHeading(root) {
  // AReviews renders section title as <p>; upgrade to <h2> for heading structure (WCAG 1.3.1 / 2.4.6).
  if (!root) return;
  var titles = root.querySelectorAll(".reviews_main_title > p");
  titles.forEach(function (title) {
    if (title.tagName === "H2") return;
    var h2 = document.createElement("h2");
    h2.className = title.className;
    Array.from(title.attributes).forEach(function (attr) {
      if (attr.name === "class") return;
      h2.setAttribute(attr.name, attr.value);
    });
    h2.innerHTML = title.innerHTML;
    title.replaceWith(h2);
  });
}

function fixAreviewsStarAria(root) {
  // Areviews injects Font Awesome <i class="fa-star">. FA SVG replacement can add
  // aria-labelledby pointing at a missing <title> id (WAVE: Broken ARIA reference).
  var scope = root && root.querySelectorAll ? root : document;
  var stars = scope.querySelectorAll
    ? scope.querySelectorAll(
        ".areviews_rating, .areviews_stars, .areviews_product_item, .areviews_header_stars"
      )
    : [];

  if (scope.matches && scope.matches(".areviews_rating, .areviews_stars, .areviews_product_item, .areviews_header_stars")) {
    stars = [scope];
  }

  stars.forEach(function (wrap) {
    wrap.querySelectorAll("i, svg, .svg-inline--fa").forEach(function (icon) {
      icon.setAttribute("aria-hidden", "true");
      icon.removeAttribute("aria-labelledby");
      icon.removeAttribute("aria-describedby");
      icon.removeAttribute("title");
      if (icon.getAttribute("role") === "img") icon.removeAttribute("role");
    });
  });
}

function patchAreviewsAccessibility(root) {
  if (!root) return;
  upgradeAreviewsHeading(root);
  processInputsInRoot(root);
  root.querySelectorAll("select, textarea").forEach(labelControlIfNeeded);
  fixAreviewsStarAria(root);
}

var AREVIEWS_MARKUP_SELECTOR =
  "#az_reviews, #Areviewsapp, #enter_reviews, .AReviewsApp, .areviews_product_item, .areviews_header_stars";

function pageHasAreviewsMarkup() {
  return Boolean(document.querySelector(AREVIEWS_MARKUP_SELECTOR));
}

function areviewsStarAriaFun() {
  if (!pageHasAreviewsMarkup()) return;

  fixAreviewsStarAria(document);
  if (!document.body || document.body.dataset.areviewsStarObserved === "1") return;
  document.body.dataset.areviewsStarObserved = "1";

  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      fixAreviewsStarAria(document);
    });
  }).observe(document.body, { childList: true, subtree: true });
}

function areviewsHeadingFun() {
  var host = document.getElementById("az_reviews") || document.getElementById("Areviewsapp");
  if (!host) return;

  patchAreviewsAccessibility(host);
  if (host.dataset.areviewsHeadingObserved === "1") return;
  host.dataset.areviewsHeadingObserved = "1";
  new MutationObserver(function () {
    patchAreviewsAccessibility(host);
  }).observe(host, { childList: true, subtree: true });
}
var SINGLE_H1_DEFAULTS = {
  // closest()：页头区域（其内的 h1 不算「内容 h1」）
  header: "header.header, sticky-header, .header-wrapper",
  // closest()：侧边购物车 / mini-cart（排除）
  cart: "cart-drawer, #CartDrawer, .cart-drawer, cart-notification, #cart-notification",
  // 主内容根（升 h2、MutationObserver 优先观察这里；支持逗号多选，取第一个匹配）
  main: "#MainContent, main",
  // 有内容 h1 时，要降级的 header logo h1
  headerLogoH1: "header.header h1.header__heading",
  // demote 后给 logo 链接补 aria-label 时用的选择器
  headerLink: ".header__heading-link",
  headerLinkLabel: ".visually-hidden",
  // 是否额外观察 document.body（插件插在 main 外时）
  observeBodyFallback: true,
};

function mergeSingleH1Config(options) {
  var fromWindow =
    typeof window !== "undefined" && window.ADA_SINGLE_H1_CONFIG && typeof window.ADA_SINGLE_H1_CONFIG === "object"
      ? window.ADA_SINGLE_H1_CONFIG
      : {};
  return Object.assign({}, SINGLE_H1_DEFAULTS, fromWindow, options || {});
}

function demoteH1ToDiv(el) {
  if (!el || el.tagName !== "H1") return null;
  if (el.dataset.adaH1Demoted === "1") return el;

  var next = document.createElement("div");
  Array.from(el.attributes).forEach(function (attr) {
    next.setAttribute(attr.name, attr.value);
  });
  next.setAttribute("data-ada-h1-demoted", "1");
  while (el.firstChild) {
    next.appendChild(el.firstChild);
  }
  el.replaceWith(next);
  return next;
}

function promoteH2ToH1(el) {
  if (!el || el.tagName !== "H2") return null;
  if (el.dataset.adaH1Promoted === "1") return el;

  var next = document.createElement("h1");
  Array.from(el.attributes).forEach(function (attr) {
    next.setAttribute(attr.name, attr.value);
  });
  next.setAttribute("data-ada-h1-promoted", "1");
  while (el.firstChild) {
    next.appendChild(el.firstChild);
  }
  el.replaceWith(next);
  return next;
}

/**
 * 单页唯一 h1
 * - 内容区只保留第一个 h1，多余 h1 → div；有内容 h1 时 header logo h1 也 → div
 * - 全页没有任何 h1 时，把 main 内第一个 h2（排除 header / cart）升为 h1
 *
 * 用法：
 * 1) 本主题默认（Dawn 选择器）：
 *    singleH1Fun();
 *
 * 2) 调用时覆盖部分选择器：
 *    singleH1Fun({
 *      header: "header, .site-header",
 *      cart: ".mini-cart, .cart-drawer",
 *      main: "#content, main",
 *      headerLogoH1: "header h1.logo",
 *      headerLink: "a.logo-link",
 *      headerLinkLabel: ".sr-only",
 *      observeBodyFallback: true,
 *    });
 *
 * 3) 在本脚本执行前设置全局配置（会与 DEFAULTS / 入参 merge，优先级：入参 > window > DEFAULTS）：
 *    window.ADA_SINGLE_H1_CONFIG = { main: "#content", header: "header" };
 *    // 然后仍调用 singleH1Fun() 或 singleH1Fun({ cart: ".drawer-cart" });
 *
 * @param {Object} [options]
 * @param {string} [options.header]
 * @param {string} [options.cart]
 * @param {string} [options.main]
 * @param {string} [options.headerLogoH1]
 * @param {string} [options.headerLink]
 * @param {string} [options.headerLinkLabel]
 * @param {boolean} [options.observeBodyFallback]
 */
function singleH1Fun(options) {
  var config = mergeSingleH1Config(options);

  function safeClosest(el, selector) {
    if (!el || !el.closest || !selector) return null;
    try {
      return el.closest(selector);
    } catch (error) {
      console.warn("singleH1Fun: invalid closest selector", selector, error);
      return null;
    }
  }

  function safeQuerySelector(root, selector) {
    if (!root || !root.querySelector || !selector) return null;
    try {
      return root.querySelector(selector);
    } catch (error) {
      console.warn("singleH1Fun: invalid querySelector", selector, error);
      return null;
    }
  }

  function safeQuerySelectorAll(root, selector) {
    if (!root || !root.querySelectorAll || !selector) return [];
    try {
      return Array.from(root.querySelectorAll(selector));
    } catch (error) {
      console.warn("singleH1Fun: invalid querySelectorAll", selector, error);
      return [];
    }
  }

  function isInsideHeader(el) {
    return Boolean(safeClosest(el, config.header));
  }

  function isInsideCart(el) {
    return Boolean(safeClosest(el, config.cart));
  }

  function isPageContentHeading(el) {
    return Boolean(el) && !isInsideHeader(el) && !isInsideCart(el);
  }

  function resolveMainRoot() {
    if (!config.main) return document.body;
    return safeQuerySelector(document, config.main) || document.body;
  }

  function ensureHeaderLinkAriaLabel(headingEl) {
    if (!headingEl || !config.headerLink) return;
    var link = safeQuerySelector(headingEl, config.headerLink);
    if (!link || (link.getAttribute("aria-label") || "").trim()) return;

    var labelEl = config.headerLinkLabel ? safeQuerySelector(headingEl, config.headerLinkLabel) : null;
    var labelText = labelEl && labelEl.textContent ? labelEl.textContent.trim() : "";
    if (!labelText) return;
    link.setAttribute("aria-label", labelText);
  }

  function findFirstContentH2() {
    var root = resolveMainRoot();
    if (!root) return null;
    return safeQuerySelectorAll(root, "h2").filter(isPageContentHeading)[0] || null;
  }

  function enforceSingleH1() {
    try {
      var allH1 = Array.from(document.querySelectorAll("h1"));
      var pageH1s = allH1.filter(isPageContentHeading);

      // No content h1: keep header-only h1, or promote first main h2 when page has zero h1s
      if (pageH1s.length === 0) {
        if (allH1.length > 0) return;

        var firstH2 = findFirstContentH2();
        if (firstH2) promoteH2ToH1(firstH2);
        return;
      }

      if (config.headerLogoH1) {
        safeQuerySelectorAll(document, config.headerLogoH1).forEach(function (headerH1) {
          var demoted = demoteH1ToDiv(headerH1);
          ensureHeaderLinkAriaLabel(demoted);
        });
      }

      pageH1s = Array.from(document.querySelectorAll("h1")).filter(isPageContentHeading);
      pageH1s.slice(1).forEach(demoteH1ToDiv);
    } catch (error) {
      console.warn("singleH1Fun: enforce failed", error);
    }
  }

  enforceSingleH1();

  if (!document.body || document.body.dataset.singleH1Observed === "1") return;
  document.body.dataset.singleH1Observed = "1";

  var scheduled = false;
  function scheduleEnforce() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      enforceSingleH1();
    });
  }

  function nodeMayAffectHeadings(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.getAttribute && node.getAttribute("data-ada-h1-demoted") === "1") return false;
    if (node.getAttribute && node.getAttribute("data-ada-h1-promoted") === "1") return false;
    return Boolean(
      (node.matches && (node.matches("h1") || node.matches("h2"))) ||
        (node.querySelector && (node.querySelector("h1") || node.querySelector("h2")))
    );
  }

  var observeRoot = resolveMainRoot();
  if (observeRoot) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (nodeMayAffectHeadings(added[j])) {
            scheduleEnforce();
            return;
          }
        }
      }
    }).observe(observeRoot, { childList: true, subtree: true });
  }

  if (config.observeBodyFallback && observeRoot && observeRoot !== document.body) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (observeRoot.contains && observeRoot.contains(node)) continue;
          if (isInsideHeader(node) || isInsideCart(node)) continue;
          if (nodeMayAffectHeadings(node)) {
            scheduleEnforce();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
}


document.addEventListener('DOMContentLoaded', () => {
  announcementAccessFun();
  targetlinkFun();
  titleroleFun();
  imgALTFun();
  svgariaFun();
  inputlabelFun();
  tabtoClickFun();
  iframeTitleFun();
  googleRatingBadgeA11yFun();
  areviewsHeadingFun();
  areviewsStarAriaFun();
  // 单页唯一 h1；换站可传参或设 window.ADA_SINGLE_H1_CONFIG，详见 singleH1Fun 上方注释
  singleH1Fun();
});
